import { Box } from '@mui/material';

export default function TwoStepStepper({ scrolledToLeft }) {
  return (
    <Box
      gridColumn='1/-1'
      height={30}
      sx={{ mx: { xs: 2, md: 6 }, mt: 3 }}
      display={{ xs: 'grid', md: 'none' }}
      gridTemplateColumns='repeat(4, 1fr)'
    >
      <Box
        gridColumn='1/3'
        sx={{
          borderTop: '1px solid',
          borderColor: 'colorTheme.backgroundPrimaryDark',
          opacity: scrolledToLeft ? '1' : '0.2',
        }}
      />
      <Box
        gridColumn='3/-1'
        sx={{
          borderTop: '1px solid',
          borderColor: 'colorTheme.backgroundPrimaryDark',
          opacity: scrolledToLeft ? '0.2' : '1',
        }}
      />
    </Box>
  );
}
